import React, { useState } from "react";

import { UrlApi } from "../../../services/apirest";

const ModalPendienteDeFinalizacion = ({
  showToast,
  datos,
  open,
  onClose,
  tabla,
  actualizar,
}) => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  if (!open) return null;

  const idReclamo = datos?.id_reclamo;

  const handleConfirmar = async () => {
    if (!idReclamo) {
      setError("No se encontró el ID del reclamo.");
      return;
    }

    setLoading(true);
    setError(null);

    try {
      const res = await fetch(
        `${UrlApi}/reclamos/pendienteDeFinalizar/${idReclamo}`,
        {
          method: "PUT",
          headers: { "Content-Type": "application/json" },
        },
      );

      const data = await res.json().catch(() => null);

      if (!res.ok) {
        throw new Error(data?.error || "No se pudo actualizar el reclamo.");
      }

      showToast("Guardado correctamente");
      actualizar();
      onClose();
    } catch (err) {
      console.error("Error al dejar en pendiente de finalizar:", err);
      setError(err.message || "Ocurrió un error inesperado.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="pdf-overlay" role="dialog" aria-modal="true">
      <div className="pdf-modal">
        <div className="pdf-icon" aria-hidden="true">
          <svg width="26" height="26" viewBox="0 0 24 24" fill="none">
            <path
              d="M12 8v5M12 16h.01"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <circle
              cx="12"
              cy="12"
              r="9"
              stroke="currentColor"
              strokeWidth="2"
            />
          </svg>
        </div>

        <h2 className="pdf-title">Marcar como pendiente de finalización</h2>

        <p className="pdf-body">
          El reclamo <strong>#{idReclamo ?? "—"}</strong> va a pasar a estado{" "}
          <strong>pendiente de finalización</strong>. Esta acción registra la
          fecha de finalización con el momento actual.
        </p>

        {error && <p className="pdf-error">{error}</p>}

        <div className="pdf-actions">
          <button
            type="button"
            className="pdf-btn pdf-btn-ghost"
            onClick={onClose}
            disabled={loading}
          >
            Volver
          </button>
          <button
            type="button"
            className="pdf-btn pdf-btn-primary"
            onClick={handleConfirmar}
            disabled={loading}
          >
            {loading ? "Confirmando..." : "Confirmar"}
          </button>
        </div>
      </div>

      <style>{`
        .pdf-overlay {
          position: fixed;
          inset: 0;
          background: rgba(15, 23, 42, 0.5);
          display: flex;
          align-items: center;
          justify-content: center;
          z-index: 1000;
          padding: 16px;
        }

        .pdf-modal {
          background: #ffffff;
          border-radius: 12px;
          padding: 28px;
          width: 100%;
          max-width: 380px;
          box-shadow: 0 20px 45px rgba(15, 23, 42, 0.25);
          text-align: left;
        }

        .pdf-icon {
          width: 44px;
          height: 44px;
          border-radius: 50%;
          background: #eef2ff;
          color: #4338ca;
          display: flex;
          align-items: center;
          justify-content: center;
          margin-bottom: 14px;
        }

        .pdf-title {
          margin: 0 0 8px;
          font-size: 17px;
          font-weight: 600;
          color: #111827;
        }

        .pdf-body {
          margin: 0 0 20px;
          font-size: 14px;
          line-height: 1.5;
          color: #4b5563;
        }

        .pdf-error {
          margin: -8px 0 16px;
          font-size: 13px;
          color: #dc2626;
        }

        .pdf-actions {
          display: flex;
          justify-content: flex-end;
          gap: 10px;
        }

        .pdf-btn {
          border: none;
          border-radius: 8px;
          padding: 9px 16px;
          font-size: 14px;
          font-weight: 500;
          cursor: pointer;
          transition: background 0.15s ease, opacity 0.15s ease;
        }

        .pdf-btn:disabled {
          opacity: 0.6;
          cursor: not-allowed;
        }

        .pdf-btn-ghost {
          background: transparent;
          color: #374151;
        }

        .pdf-btn-ghost:hover:not(:disabled) {
          background: #f3f4f6;
        }

        .pdf-btn-primary {
          background: #4338ca;
          color: #ffffff;
        }

        .pdf-btn-primary:hover:not(:disabled) {
          background: #362da3;
        }
      `}</style>
    </div>
  );
};

export default ModalPendienteDeFinalizacion;
